export const state = () => ({
  list: [],
});

export const getters = {
  getList(state) {
    return state.list;
  },
};

export const mutations = {
  addMessage(state, message) {
    state.list.push(message);
  },
};

export const actions = {
  sendMessage({ commit }, data) {
    commit('addMessage', {
      msg: data.msg,
      imgUrl: data.imgUrl,
      timestamp: data.timestamp,
      nick: data.nick,
      displayName: data.display_name,
    });
  },
};
